import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import Routes from "./legacyRoutes";
import NewUXRoutes from "./newUXRoutes";

const MultiRouter = () => {
  const { user, serviceProviderLoggingAsAnExhibitor, adminToken } = useSelector(
    (state) => state.auth
  );

  const isServiceProvider = useCallback(
    () =>
      !adminToken &&
      (serviceProviderLoggingAsAnExhibitor ||
        user?.role?.type === "SERVICE_PROVIDER"),
    [adminToken, serviceProviderLoggingAsAnExhibitor, user?.role?.type]
  );

  const isExhibitor = useCallback(
    () => !adminToken && user?.role?.type === "EXHIBITOR",
    [adminToken, user?.role?.type]
  );

  const isSponsor = useCallback(
    () => !adminToken && user?.role?.type === "SPONSOR_WITHOUT_M2",
    [adminToken, user?.role?.type]
  );

  const isDigital = useCallback(
    () => !adminToken && user?.role?.type === "DIGITAL_ONLY",
    [adminToken, user?.role?.type]
  );

  return isExhibitor()
      || isServiceProvider()
      || isSponsor()
      || isDigital()
      || adminToken ? (
    <NewUXRoutes />
  ) : (
    <Routes />
  );
};

export default MultiRouter;
